import { organizationBrandName } from './organizationBrand';

const displayNameOf = (user) => {
  const full = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim();
  return full || user?.username?.trim() || '';
};

export const appWindowTitle = (user, unreadCount = 0) => {
  const name = displayNameOf(user);
  const brand = organizationBrandName(user, 'WorkLoop');
  const base = name ? `${brand} - ${name}` : brand;
  const unread = Number(unreadCount) || 0;
  return unread > 0 ? `(${unread}) ${base}` : base;
};

export const applyWindowTitle = (user, unreadCount = 0) => {
  const title = appWindowTitle(user, unreadCount);
  if (typeof document !== 'undefined') {
    document.title = title;
  }
  try {
    window.workloopRealm?.setWindowTitle?.(title);
  } catch {
    // Browser / preload without the helper
  }
};
